import React from 'react'
import ButtonClose from '../../atoms/button-close/button-close'
import './layout-modal.scss'

export const LayoutModal = ({
  children,
  childrenBG,
  close,
  className = '',
}: {
  children: React.JSX.Element
  childrenBG: React.JSX.Element
  close: () => void
  className?: string
}) => {
  return (
    <div className={'f-layoutModal-container ' + className}>
      <div className="f-layoutModal-container__wrapper">
        <ButtonClose onClick={close} />
        <figure className="f-layoutModal-container__figure">
          {childrenBG}
        </figure>
        <section className="f-layoutModal-container__section">
          {children}
        </section>
      </div>
    </div>
  )
}
